import React from 'react';
import { personalInfo } from '../data/mockData';
import { Mail, Phone, Linkedin, Github, MapPin, ArrowUpRight, Heart } from 'lucide-react';
import { Separator } from './ui/separator';

const ContactFooter = () => {
  return (
    <>
      <section id="contact" className="py-24">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex items-center gap-3 mb-12">
            <div className="h-px w-12 bg-emerald-500"></div>
            <h2 className="font-mono text-sm uppercase tracking-widest text-emerald-600 dark:text-emerald-400">
              Contact
            </h2>
          </div>

          <div className="max-w-2xl">
            <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
              Let's Connect
            </h3>
            <p className="text-gray-500 dark:text-gray-400 mb-10 leading-relaxed">
              I'm always open to discussing new opportunities, interesting projects, 
              or just having a chat about technology. Feel free to reach out!
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              <a
                href={`mailto:${personalInfo.email}`}
                className="group flex items-center gap-4 p-5 rounded-xl bg-gray-50 dark:bg-white/[0.02] border border-gray-200 dark:border-white/5 hover:border-emerald-200 dark:hover:border-emerald-500/20 transition-colors duration-200"
              >
                <div className="p-2.5 rounded-lg bg-emerald-100 dark:bg-emerald-500/10">
                  <Mail className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-gray-400 dark:text-gray-500 mb-0.5">Email</p>
                  <p className="text-sm text-gray-900 dark:text-white truncate">{personalInfo.email}</p>
                </div>
                <ArrowUpRight className="h-4 w-4 text-gray-300 dark:text-gray-600 group-hover:text-emerald-500 transition-colors" />
              </a>

              <a
                href={personalInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-4 p-5 rounded-xl bg-gray-50 dark:bg-white/[0.02] border border-gray-200 dark:border-white/5 hover:border-emerald-200 dark:hover:border-emerald-500/20 transition-colors duration-200"
              >
                <div className="p-2.5 rounded-lg bg-emerald-100 dark:bg-emerald-500/10">
                  <Linkedin className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-gray-400 dark:text-gray-500 mb-0.5">LinkedIn</p>
                  <p className="text-sm text-gray-900 dark:text-white">Abhinav Kr. Singh</p>
                </div>
                <ArrowUpRight className="h-4 w-4 text-gray-300 dark:text-gray-600 group-hover:text-emerald-500 transition-colors" />
              </a>

              <a
                href={`tel:${personalInfo.phone}`}
                className="group flex items-center gap-4 p-5 rounded-xl bg-gray-50 dark:bg-white/[0.02] border border-gray-200 dark:border-white/5 hover:border-emerald-200 dark:hover:border-emerald-500/20 transition-colors duration-200"
              >
                <div className="p-2.5 rounded-lg bg-emerald-100 dark:bg-emerald-500/10">
                  <Phone className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-gray-400 dark:text-gray-500 mb-0.5">Phone</p>
                  <p className="text-sm text-gray-900 dark:text-white">{personalInfo.phone}</p>
                </div>
                <ArrowUpRight className="h-4 w-4 text-gray-300 dark:text-gray-600 group-hover:text-emerald-500 transition-colors" />
              </a>

              <div className="flex items-center gap-4 p-5 rounded-xl bg-gray-50 dark:bg-white/[0.02] border border-gray-200 dark:border-white/5">
                <div className="p-2.5 rounded-lg bg-emerald-100 dark:bg-emerald-500/10">
                  <MapPin className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-gray-400 dark:text-gray-500 mb-0.5">Location</p>
                  <p className="text-sm text-gray-900 dark:text-white">{personalInfo.location}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 border-t border-gray-200 dark:border-white/5">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              &copy; {new Date().getFullYear()} {personalInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-1 text-sm text-gray-400 dark:text-gray-500">
              Built with <Heart className="h-3.5 w-3.5 text-emerald-500 mx-1" /> and React
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default ContactFooter;